import request from '@/utils/request'

/* 获取公司 */
export function getCompanyList(data) {
  return request({
    url: 'alp/company/list',
    data
  })
}

/* 获取管理人员列表 */
export function getUserList(data) {
  return request({
    url: 'alp/admin_user/list',
    data
  })
}

/* 获取权限组列表 */
export function getRoleList(data) {
  return request({
    url: 'alp/role/list',
    data
  })
}

/* 添加管理员 */
export function getAddAdminUser(data) {
  return request({
    url: 'alp/admin_user/add',
    data
  })
}

/* 修改管理员 */
export function getEditAdminUser(data) {
  return request({
    url: 'alp/admin_user/edit',
    data
  })
}

/* 获取个人信息 */
export function getDetailAdminUser(data) {
  // if (!data) { data = undefined }
  // console.log('获取个人信息', 8888)
  return request({
    url: 'alp/admin_user/detail',
    data
  })
}

/** 获取个人权限 */
export function getPermission(data) {
  return request({
    url: 'alp/admin_user/get_privileges',
    data
  })
}

/* 核销用户获取 */
export function getVerifiedUserList(data) {
  return request({
    url: 'alp/verified_user/list',
    data
  })
}

/* 新增核销用户 */
export function getAddVerifiedUser(data) {
  return request({
    url: 'alp/verified_user/add',
    data
  })
}

/* 新增核销用户 */
export function getVerifiedUserQrcode(data) {
  return request({
    url: 'alp/verified_user/qrcode',
    data
  })
}

/* 系统客服列表获取 */
export function getSystemList(data) {
  return request({
    url: 'alp/service_user/list',
    data
  })
}

/* 添加系统客服 */
export function getSystemAdd(data) {
  return request({
    url: 'alp/service_user/add',
    data
  })
}

/* 添加系统客服 */
export function getSystemEdit(data) {
  return request({
    url: 'alp/service_user/edit',
    data
  })
}

/* 删除客服 */
export function getSystemDel(data) {
  return request({
    url: 'alp/service_user/del',
    data
  })
}
